// Copied from the dashboard (frontend_v2/src/components) — keep in step.
// Row of summary cards (Servers, Containers). Each card can act as a filter:
// pass onClick + active and the card highlights while its filter is on.
//
//   <StatCards cards={[{ key, label, value, sub, color, icon: Server, onClick, active }]} />
//
// `color` is per card (any CSS color), so it is passed as the --card-color
// variable and read by the arbitrary-value classes below.
export default function StatCards({ cards }) {
    return (
        <div className="tw-mb-4 tw-grid tw-grid-cols-[repeat(auto-fit,minmax(170px,1fr))] tw-gap-3">
            {cards.map(c => {
                const Icon = c.icon
                const clickable = !!c.onClick
                return (
                    <div key={c.key}
                        style={{ '--card-color': c.color || 'var(--text-muted)' }}
                        onClick={c.onClick}
                        role={clickable ? 'button' : undefined}
                        title={c.title}
                        className={[
                            'tw-min-w-0 tw-rounded-[10px] tw-border tw-border-t-[3px] tw-border-solid tw-px-4 tw-py-3.5 tw-transition',
                            'tw-border-border tw-border-t-[var(--card-color)]',
                            clickable && 'tw-cursor-pointer hover:-tw-translate-y-px',
                            c.active
                                ? 'tw-border-[var(--card-color)] tw-bg-[color-mix(in_srgb,var(--card-color)_10%,var(--bg-card))]'
                                : 'tw-bg-card'
                        ].filter(Boolean).join(' ')}>
                        <div className="tw-flex tw-items-center tw-justify-between tw-gap-2">
                            <span className="tw-text-[11px] tw-font-semibold tw-uppercase tw-tracking-wider tw-text-muted">{c.label}</span>
                            {Icon && <span className="tw-inline-flex tw-text-[var(--card-color)] tw-opacity-85"><Icon size={16} /></span>}
                        </div>
                        <div className="tw-mt-1.5 tw-text-[26px] tw-font-bold tw-leading-tight tw-tabular-nums tw-text-[var(--card-color)]">
                            {c.value ?? '—'}
                        </div>
                        {c.sub && <div className="tw-mt-1 tw-truncate tw-text-xs tw-text-muted">{c.sub}</div>}
                    </div>
                )
            })}
        </div>
    )
}
